import React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';
const AlgoliaHasListRefinementContext = /*#__PURE__*/React.createContext();
const {
  Provider
} = AlgoliaHasListRefinementContext;
const AlgoliaHasListRefinement = /*#__PURE__*/React.memo(_ref => {
  let {
    attribute,
    children,
    items
  } = _ref;
  const attributes = Array.isArray(attribute) ? attribute : [attribute];
  const refinedAttributes = items.map(i => i.attribute);
  const hasRefinement = attributes.reduce((hasRefinement, attribute) => {
    if (!hasRefinement && refinedAttributes.includes(attribute)) {
      return true;
    }
    return hasRefinement;
  }, false);
  return /*#__PURE__*/React.createElement(Provider, {
    value: hasRefinement
  }, children);
});
AlgoliaHasListRefinement.propTypes = {};
AlgoliaHasListRefinement.defaultProps = {};
AlgoliaHasListRefinement.displayName = 'AlgoliaHasListRefinement';
export default connectCurrentRefinements(AlgoliaHasListRefinement);
export { AlgoliaHasListRefinementContext };